const inputFilter = {
  // la directiva define una funcion (recibida en binding.value) que devuelve true o false para saber si el input cumple con el filtro
  // ej: v-input-filter="(value) => /^\d*$/.test(value)" hace que el input solo permita ingresar numeros
  // see: https://stackoverflow.com/questions/469357/html-text-input-allow-only-numeric-input
  inserted: function (el, binding, vnode) {
    ;['input', 'keydown', 'keyup', 'mousedown', 'mouseup', 'select', 'contextmenu', 'drop'].forEach(
      function (event) {
        el.addEventListener(event, function () {
          if (binding.value(this.value)) {
            this.oldValue = this.value
            this.oldSelectionStart = this.selectionStart
            this.oldSelectionEnd = this.selectionEnd
          } else if (this.hasOwnProperty('oldValue')) {
            this.value = this.oldValue
            vnode.elm.dispatchEvent(new CustomEvent('input')) // fix para que funcione bien con v-model
            this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd)
          } else {
            this.value = ''
            vnode.elm.dispatchEvent(new CustomEvent('input')) // fix para que funcione bien con v-model
          }
        })
      }
    )
  },
}

export default {
  name: 'input-filter',
  directive: inputFilter,
}
